import React,{useState} from "react";
import { Link, useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import {
    loadingToggleAction,
} from '../../store/actions/AuthActions';
import { useWallet } from '../../context/WalletContext';
import { register } from '../../services/authApiService';
import logo from "../../images/logo-full.png";
import ForgotPasswordModal from "../components/Auth/ForgotPasswordModal";
import ResetPasswordModal from "../components/Auth/ResetPasswordModal";

function Register(props) {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    let errorsObj = { email: '', password: '', name: '', wallet: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [password, setPassword] = useState('');
    const [passwordValidation, setPasswordValidation] = useState({
        hasMinLength: false,
        hasLetter: false,
        hasNumber: false,
        hasSpecialChar: false,
    });
    const [showForgotModal, setShowForgotModal] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [isRegistering, setIsRegistering] = useState(false);
    const [registrationError, setRegistrationError] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isConnected, address } = useWallet();

    const validatePassword = (pwd) => {
        setPassword(pwd);
        setPasswordValidation({
            hasMinLength: pwd.length >= 8,
            hasLetter: /[a-zA-Z]/.test(pwd),
            hasNumber: /[0-9]/.test(pwd),
            hasSpecialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd),
        });
    };

    const isPasswordValid = 
        passwordValidation.hasMinLength &&
        passwordValidation.hasLetter &&
        passwordValidation.hasNumber &&
        passwordValidation.hasSpecialChar;

    async function onSignUp(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        
        if (name.trim() === '') {
            errorObj.name = 'Name is Required';
            error = true;
        }
        
        if (email === '') {
            errorObj.email = 'Email is Required';
            error = true;
        }
        
        if (password === '') {
            errorObj.password = 'Password is Required';
            error = true;
        } else if (!isPasswordValid) {
            errorObj.password = 'Password must contain at least 8 characters, one letter, one number and one special character';
            error = true;
        }

        // Wallet no es requerida para registro inicial (se puede conectar después)
        // Pero si está conectada, la usamos
        if (!isConnected || !address) {
            errorObj.wallet = 'Please connect your wallet to register';
            error = true;
        }
        
        setErrors(errorObj);
        setRegistrationError('');
        if (error) return;

        setIsRegistering(true);
        dispatch(loadingToggleAction(true));

        try {
            // Usar el nuevo servicio de registro que permite registro sin NFT
            // El backend marcará requiresSponsorAtPurchase: true automáticamente
            const result = await register(name.trim(), email.trim(), password, address);
            
            if (result.success) {
                // Registro exitoso - redirigir a página de bienvenida o trading
                // El usuario tendrá acceso limitado hasta que compre NFT
                dispatch(loadingToggleAction(false));
                navigate('/trading', { 
                    state: { 
                        message: 'Registration successful! Please purchase an NFT to unlock full access.',
                        requiresNFT: true 
                    } 
                });
            } else {
                setRegistrationError(result.message || 'Registration failed');
                dispatch(loadingToggleAction(false));
            }
        } catch (err) {
            console.error('[Registration] Error:', err);
            setRegistrationError(err.message || 'Error al registrar usuario');
            dispatch(loadingToggleAction(false));
        } finally {
            setIsRegistering(false);
        }
    }
  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to="/page-login">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4 ">Registra tu cuenta</h4>
                      {props.errorMessage && (
                        <div className=''>
                          {props.errorMessage}
                        </div>
                      )}
                      {props.successMessage && (
                        <div className=''>
                          {props.successMessage}
                        </div>
                      )}
                    <form onSubmit={onSignUp}>
                      <div className="form-group mb-3">
                        <label className="mb-1 ">
                          <strong>Nombre Completo</strong>
                        </label>
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          className="form-control"
                          placeholder="Ingresa tu nombre completo"
                          required
                        />
                        {errors.name && <div className="text-danger small">{errors.name}</div>}
                      </div>
                      <div className="form-group mb-3">
                        <label className="mb-1 ">
                          <strong>Correo Electrónico</strong>
                        </label>
                        <input
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control"
                          placeholder="correo@ejemplo.com"
                        />
                      </div>
					            {errors.email && <div>{errors.email}</div>}
                      <div className="form-group mb-3">
                        <label className="mb-1 ">
                          <strong>Contraseña</strong>
                        </label>
                        <input
                          type="password"
                          value={password}
                          onChange={(e) => validatePassword(e.target.value)}
                          className="form-control"
                          placeholder="Ingresa una contraseña segura"
                        />
                        <div className="password-requirements mt-2">
                          <div className={passwordValidation.hasMinLength ? "text-success small" : "text-muted small"}>
                            {passwordValidation.hasMinLength ? "✓" : "○"} Mínimo 8 caracteres
                          </div>
                          <div className={passwordValidation.hasLetter ? "text-success small" : "text-muted small"}>
                            {passwordValidation.hasLetter ? "✓" : "○"} Al menos una letra
                          </div>
                          <div className={passwordValidation.hasNumber ? "text-success small" : "text-muted small"}>
                            {passwordValidation.hasNumber ? "✓" : "○"} Al menos un número
                          </div>
                          <div className={passwordValidation.hasSpecialChar ? "text-success small" : "text-muted small"}>
                            {passwordValidation.hasSpecialChar ? "✓" : "○"} Al menos un carácter especial (!@#$%^&*)
                          </div>
                        </div>
                      </div>
					              {errors.password && <div className="text-danger small">{errors.password}</div>}
                      
                      {/* Wallet Status */}
                      <div className="form-group mb-3">
                        <label className="mb-1 ">
                          <strong>Wallet</strong>
                        </label>
                        {isConnected && address ? (
                          <div className="alert alert-success small mb-0">
                            ✓ Wallet conectada: {address.slice(0, 6)}...{address.slice(-4)}
                          </div>
                        ) : (
                          <div className="alert alert-warning small mb-0">
                            ⚠️ Por favor conecta tu wallet para continuar
                          </div>
                        )}
                        {errors.wallet && <div className="text-danger small">{errors.wallet}</div>}
                      </div>

                      {/* Registration Error */}
                      {registrationError && (
                        <div className="alert alert-danger small">
                          {registrationError}
                        </div>
                      )}

                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={!isPasswordValid || !email || !name.trim() || !isConnected || !address || isRegistering}
                        >
                          {isRegistering ? 'Registrando...' : 'Registrarme'}
                        </button>
                      </div>
                      
                      <div className="text-center mt-3">
                        <small className="text-muted">
                          Al registrarte, podrás acceder con acceso limitado. Deberás comprar un NFT ($30) para desbloquear todas las funciones.
                        </small>
                      </div>
                    </form>
                    <div className="new-account mt-3 text-center">
                      <p>
                        ¿Ya tienes una cuenta?{" "}
                        <Link to="/login" className="text-primary">
                          Iniciar Sesión
                        </Link>
                      </p>
                      <p>
                        <button
                          type="button"
                          onClick={() => {
                            setShowForgotModal(true);
                          }}
                          className="text-primary btn btn-link p-0"
                          style={{ textDecoration: 'none' }}
                        >
                          ¿Olvidaste tu Contraseña?
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ForgotPasswordModal
        show={showForgotModal}
        onHide={() => setShowForgotModal(false)}
      />

      <ResetPasswordModal
        show={showResetModal}
        onHide={() => setShowResetModal(false)}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
    };
};

export default connect(mapStateToProps)(Register);